export const FieldList = [
    // {
    //     label:"Spice Level",
    //     key: "allow_spice_level"
    // },
    {
        label:"Vegetarian",
        key: "allow_vegetarian"
    },
    {
        label:"Calories",
        key: "allow_calories"
    },
    {
        label:"Description",
        key: "allow_description"
    },
    {
        label:"Gluten free",
        key: "allow_gluten_free"
    },
    {
        label:"Vegan",
        key: "allow_vegan"
    },
    {
        label:"Dairy",
        key: "allow_dairy"
    },
    {
        label:"Nuts",
        key: "allow_nuts"
    }
];